import api from './api';

export const getUserSession = async token => {
    const response = await api.request({
        method: 'get',
        url: '/session-token',
        params: {
            token
        }
    });
    return response.data;
};
